import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { RootState, AppDispatch } from './store'

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const useWindowSize = () => {
    const windowSize = useAppSelector(state => state.window)
    return windowSize
}

export const useAuth = () => {
    const auth = useAppSelector(state => state.auth)
    return auth
}

export const useHospitalContext = () => {
    return useAppSelector(state => state.hospitalContext)
}
